// extracted by mini-css-extract-plugin
export var error = "loader-module--error--l3Rz7";
export var loader = "loader-module--loader--dYhXb";
export var loaderContainer = "loader-module--loaderContainer--ymqwL";
export var spin = "loader-module--spin--1HfJA";